
<div class="costs" *ngIf="basket.items.length">
    <mat-card class="mb-3 mt-3">
        <h2 class="mat-title mb-2">Dining</h2>

    <div class="addOns-cost-container">
        <div *ngFor="let item of basket.items; let i = index">

        <div class="row">
            <div class="col-6">
                <!-- <p class="fs-4 fs-regular">Dining</p> -->
            </div>
            <div class="col-6 text-right">
                <button *ngIf="!item.tableBooking" class="btn btn-small btn-primary" (click)="dining(i)">Make a reservation</button>
            </div>
        </div>

            <div *ngIf="item.tableBooking">
                <p style="font-size: 15px;" class="mb-0">
                    Your table booking for {{item.tableBooking.partySize}} at {{item.tableBooking.slotSelected | date: 'HH:mm'}} is confirmed
                </p>
                <p style="font-size: 15px;" class=" mt-0 text-danger">
                    <span *ngIf="secondsRemaining(i) > 0">
                    {{ formatRemaining(secondsRemaining(i)) }}
                    </span>
                    <span> remaining to checkout before your reservation expires</span>
                    <span *ngIf="secondsRemaining(i) === 0">
                    Your table booking has expired
                    </span>

                </p>

                <div class="text-right">
                    <button class="btn btn-small btn-primary" (click)="removeOpenTable(i)">Remove reservation</button>
                </div>

            </div>
            </div>
            </div>

</mat-card>
</div>

<div class="costs" *ngIf="basket.items.length">

    <mat-card class="mb-3 mt-3" *ngIf="basket.items[0].booking.planSelected.options && basket.items[0].booking.planSelected.options.length">

    <div class="addOns-cost-container">
        <div *ngFor="let item of basket.items; let i = index">

        <div class="sub-tile" *ngIf="item.booking.planSelected.options && item.booking.planSelected.options.length">
                        <h2 class="mat-title mb-1">Choose between Afternoon Tea or Dinner for two</h2>
                        <div class="row">
                            <div class="col-6">
                                <p class="mb-0" style="font-size: 15px;">Select your preference</p>
                            </div>
                            <div class="col-6 text-right">
                                <div class="row" *ngFor="let o of item.booking.planSelected.options; let odx = index">
                                    <div class="col-10" style="font-size: 15px;">{{o.text}}</div>
                                    <div class="col-2 text-right">
                                        <a (click)="toggleOptionSelected(i, odx)">
                                            <i class="fa fa-check-circle" [ngClass]="{'text-success' : o.selected, 'text-lite' : !o.selected}"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row g-3 align-items-center">
                            <div class="col-auto">
                                <label class="col-form-label" style="font-size: 15px;">Please enter your preferred time</label>
                            </div>
                            <div class="col">

                                <select style="max-width: 250px; float: right;" *ngIf="item.booking.planSelected.optionsText === 'Afternoon Tea'" class="form-control" [(ngModel)]="item.booking.planSelected.optionText">
                                    <option value="14:00">14:00</option>
                                    <option value="14:15">14:15</option>
                                    <option value="14:30">14:30</option>
                                    <option value="14:45">14:45</option>
                                    <option value="15:00">15:00</option>
                                    <option value="15:15">15:15</option>
                                    <option value="15:30">15:30</option>
                                    <option value="15:45">15:45</option>
                                    <option value="16:00">16:00</option>
                                    <option value="16:15">16:15</option>
                                    <option value="16:30">16:30</option>
                                </select>

                                <select style="max-width: 250px; float: right;" *ngIf="item.booking.planSelected.optionsText === 'Dinner'" class="form-control" [(ngModel)]="item.booking.planSelected.optionText">
                                    <option value="17:00">17:00</option>
                                    <option value="17:15">17:15</option>
                                    <option value="17:30">17:30</option>
                                    <option value="17:45">17:45</option>

                                    <option value="18:00">18:00</option>
                                    <option value="18:15">18:15</option>
                                    <option value="18:30">18:30</option>
                                    <option value="18:45">18:45</option>

                                    <option value="19:00">19:00</option>
                                    <option value="19:15">19:15</option>
                                    <option value="19:30">19:30</option>
                                    <option value="19:45">19:45</option>

                                    <option value="20:00">20:00</option>
                                    <option value="20:15">20:15</option>
                                    <option value="20:30">20:30</option>
                                </select>



                                <!-- <input type="text" [(ngModel)]="item.booking.planSelected.optionText" class="form-control" style="max-width: 250px; float: right;"> -->
                            </div>
                        </div>
                    </div>

        </div>
    </div>
    </mat-card>

    <mat-card class="mb-3 mt-3">
        <h2 class="mat-title mb-2">Spa & Treatments</h2>

    <div class="addOns-cost-container">
        <div *ngFor="let item of basket.items; let i = index">



            <div class="sub-tile" *ngIf="item.room.allowSpa || item.room.hotelId === 'HOTEL002' || item.booking.planSelected.ratePlanCode === 'FFCRU'">
                <div class="row mb-3">
                    <div class="col-6">
                    </div>
                    <div class="col-6 text-right">
                        <button *ngIf="item.room.hotelId === 'HOTEL002'" class="btn btn-small btn-primary" (click)="viewTreatments(i)">Add treatments</button>
                    </div>
                </div>
                <div *ngIf="item.room.hotelId === 'HOTEL005'">
                    <!-- <p class="fs-3 fs-regular mb-1">FFOLKESPA Thermal Spa access has been added to your reservation. Click below to add a treatment or ritual to your sessions; spaces fill up fast!</p> -->

                    <div class="alert alert-warning text-center">
                        <p class="mb-0">FFOLKESPA Thermal Spa access has been added to this reservation - TRY TO UPSELL A TREATMENT NOW!</p>
                    </div>
                    <div class="row">
                        <div class="col-9">
                            <a class="hover" style="font-size: 15px;" (click)="toggleSpaView(i)">
                                <i *ngIf="!item.spaView" style="font-size: 14px;" class="fa fa-circle-chevron-down text-warning"></i>
                                <i *ngIf="item.spaView" style="font-size: 15px;" class="fa fa-circle-chevron-up text-warning"></i>
                                View and manage your spa package
                            </a>
                        </div>
                        <div class="col-3 text-right">
                            <!-- <button *ngIf="!item.spaView" class="btn btn-small btn-block btn-primary" (click)="toggleSpaView(i)">View <i class="fa fa-circle-chevron-down"></i></button>
                            <button *ngIf="item.spaView" class="btn btn-small btn-block btn-primary" (click)="toggleSpaView(i)">Hide <i class="fa fa-chevron-up"></i></button> -->
                        </div>
                    </div>

                </div>

                <!-- <ng-container *ngIf="item.spa.trybeBasket && item.spa.trybeBasket.items.length">
                    <app-trb-basket [basketItem]="item" [basketItemIdx]="i" [allowDelete]="false"></app-trb-basket>
                </ng-container> -->
                <div *ngIf="!item.spa || !item.spa.trybeBasket || !item.spa.trybeBasket.items.length">
                    <p>Spoil yourself to a treatment whilst staying with us!</p>
                </div>

                <ng-container *ngIf="item.room.hotelId === 'HOTEL002'">
                    <div class="addOns-cost-container" *ngIf="item.spa.trybeBasket && item.spa.trybeBasket.items.length">
                        <table class="table mb-0">
                            <tr *ngFor="let t of item.spa.trybeBasket.items; let ti = index">
                                <td class="fs-2">
                                    <p class="spa-title mb-1" *ngIf="t.offering_type !== 'package'">{{t.offering_name}} - {{t.time | date: 'dd/MM/yyyy @ HH:mm'}}</p>

                                    <ng-container *ngIf="t.offering_type === 'package'">
                                        <ng-container *ngFor="let pi of t.package_items; let p = index">
                                            <ng-container  *ngIf="pi.offering_type !== 'appointment'">
                                                <p class="spa-subtitle mb-1">
                                                    {{pi.offering_name}} - {{t.guests[0].name}}
                                                </p>
                                                <p class="spa-subtitle mb-1">{{pi.time | date: 'dd/MM/yyyy @ HH:mm'}}</p>

                                            </ng-container>


                                            <!-- <ng-container  *ngIf="pi.offering_type === 'appointment'">
                                                <div>
                                                    {{pi.offering_name}} ({{pi.duration}} mins)
                                                    <a class="hover" (click)="confirmRemovePackageOption(i, ti, p)">
                                                        <i class="fa fa-trash" style="color: #CCC;"></i>
                                                    </a>
                                                        <br />
                                                    {{pi.time | date: 'dd/MM/yyyy @ HH:mm' }}
                                                </div>

                                            </ng-container> -->
                                            <!-- <ng-container *ngFor="let subPackage of pi">
                                            </ng-container> -->

                                        </ng-container>
                                    </ng-container>


                                    <ng-container *ngIf="t.offering_type !== 'package'">
                                        <p class="spa-subtitle mb-1" *ngFor="let g of t.guests">Guest name: {{g.name}}</p>
                                    </ng-container>

                                    <!-- <ng-container  *ngIf="t.offering_type === 'package' && t.package_items.length > 1">
                                        <a class="hover" (click)="triggerPackageItemModal(i, ti)">
                                            <i class="fa fa-trash text-danger"></i> Remove treatment
                                        </a>
                                </ng-container> -->

                                </td>


                                <td class="fs-2 text-right">
                                    {{t.total_cost / 100 | currency : 'GBP'}}
                                </td>
                            </tr>
                            <tr>
                                <td class="mat-title mb-2">Total spa & treatment costs</td>
                                <td class="mat-title mb-2 text-right">{{item.checkoutTotals.costs.treatments | currency: 'GBP'}}</td>
                            </tr>
                        </table>

                    </div>

                </ng-container>


                <ng-container *ngIf="item.room.hotelId === 'HOTEL005'">
                    <div class="addOns-cost-container" *ngIf="item.spa.trybeBasket && item.spa.trybeBasket.items.length">
                            <ng-container *ngFor="let t of item.spa.trybeBasket.items; let ti = index">
                                <p class="mb-1" *ngIf="t.offering_type !== 'package'">{{t.offering_name}} - {{t.time | date: 'dd/MM/yyyy @ HH:mm'}}</p>
<div class="sub-tile" *ngIf="item.spaView">
                                <table class="table mb-0">

                                        <ng-container *ngIf="t.offering_type === 'package'">
                                            <ng-container *ngFor="let pi of t.package_items; let p = index">

                                                <tr>
                                                    <td class="fs-2" [ngClass]="{'no-underline' : !p, 'underline' : p}">

                                                <ng-container  *ngIf="!p">
                                                    <p class="spa-title mb-1">
                                                        {{pi.offering_name}} - {{t.guests[0].name}}
                                                    </p>
                                                    <p class="spa-subtitle mb-1">{{pi.time | date: 'dd/MM/yyyy @ HH:mm'}}</p>

                                                </ng-container>


                                                <ng-container  *ngIf="pi.offering_type === 'appointment' || p">
                                                    <div class="spa-subtitle">
                                                        {{pi.offering_name}} ({{pi.duration}} mins)
                                                        <a class="hover" (click)="confirmRemovePackageOption(i, ti, p)">
                                                            <i class="fa fa-trash" style="color: #CCC;"></i>
                                                        </a>
                                                            <br />
                                                        {{pi.time | date: 'dd/MM/yyyy @ HH:mm' }}
                                                    </div>

                                                </ng-container>
                                                <!-- <ng-container *ngFor="let subPackage of pi">
                                                </ng-container> -->
                                                <ng-container  *ngIf="!p">
                                                        <a class="hover" (click)="triggerPackageItemModal(i, ti, p)">
                                                            <i class="fa fa-plus-circle text-warning"></i> Add a treatment to this session
                                                        </a>
                                                </ng-container>
                                            </td>


                                        <td class="fs-2 text-right" [ngClass]="{'no-underline' : !p, 'underline' : p}">
                                            <span class="fs-4 fs-regular" *ngIf="!p">{{t.total_cost / 100 | currency : 'GBP'}}</span>
                                            <span class="fs-4 fs-regular" *ngIf="p">{{pi.price_change / 100 | currency : 'GBP'}}</span>
                                        </td>
                                        </tr>

                                            </ng-container>

                                        </ng-container>


                                        <ng-container *ngIf="t.offering_type !== 'package'">
                                            <p class="mb-1" *ngFor="let g of t.guests">Guest name: {{g.name}}</p>
                                        </ng-container>

                                        <!-- <ng-container  *ngIf="t.offering_type === 'package' && t.package_items.length > 1">
                                            <a class="hover" (click)="triggerPackageItemModal(i, ti)">
                                                <i class="fa fa-trash text-danger"></i> Remove treatment
                                            </a>
                                    </ng-container> -->

                                </table>

</div>
                            </ng-container>
                            <table class="table mb-0">
                            <tr>
                                <td class="mat-title mb-2">Total spa & treatment costs</td>
                                <td class="mat-title mb-2 text-right">{{item.checkoutTotals.costs.treatments | currency: 'GBP'}}</td>
                            </tr>
                        </table>

                    </div>

                </ng-container>



            </div>

        </div>

 </div>
</mat-card>
</div>

<!-- <app-availability-rateplan-info *ngIf="(overlays$ | async).ratePlanInfo" [ratePlan]="(infoPlan$ | async)"></app-availability-rateplan-info> -->
<!-- <app-trb-treatment *ngIf="offeringInfo" [offering]="offeringInfo" (cancelled)="closeOfferingModal($event)"></app-trb-treatment> -->
<app-spa-package-items-modal *ngIf="showPackageItemsModal" [treatments]="treatments" [modalTreatmentsIdx]="modalTreatmentsIdx" [packageData]="packageData" (complete)="spaItemsComplete($event)"></app-spa-package-items-modal>


<app-confirmation *ngIf="showConfirmation" [data]="confirmationData" (complete)="removePackageOption($event)"></app-confirmation>
